var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import Project from './Project.vue';
import { namespace } from 'vuex-class';
const service = namespace('Service');
let RelatedProjectsList = class RelatedProjectsList extends Vue {
    constructor() {
        super(...arguments);
        this.moreProjects = [];
        this.slice = 0;
        this.displayShowMoreButton = false;
    }
    mounted() {
        if (this.sectors.length > 0) {
            this.displayShowMoreButton = this.showMore;
        }
        else {
            this.displayShowMoreButton = this.showMore && this.otherProjects.length > 0;
        }
    }
    checkIfMoreProjects() {
        this.displayShowMoreButton = this.projects.length > this.slice;
    }
    onMoreProjects() {
        const sectorId = this.sectors;
        const excludes = this.data.map((project) => project.id);
        if (!this.projects.length || this.projects.length == 0) {
            if (this.sectors.length > 0) {
                this.getProjects({
                    relatedToCategories: sectorId,
                    excludes: excludes,
                    siteId: window.cibbic.siteId
                });
            }
            else {
                this.setProjects(this.otherProjects);
            }
        }
        else if (this.projects.length > this.slice - 2) {
            this.moreProjects = this.moreProjects.concat(this.projects.slice(this.slice, this.slice + 2));
            this.slice += 2;
            this.checkIfMoreProjects();
        }
    }
    onProjectsChanged() {
        this.moreProjects = this.moreProjects.concat(this.projects.slice(this.slice, this.slice + 2));
        this.slice += 2;
        this.checkIfMoreProjects();
    }
};
__decorate([
    Prop({ type: Object })
], RelatedProjectsList.prototype, "labels", void 0);
__decorate([
    Prop({ type: Array })
], RelatedProjectsList.prototype, "data", void 0);
__decorate([
    Prop()
], RelatedProjectsList.prototype, "showMore", void 0);
__decorate([
    Prop({ type: Array })
], RelatedProjectsList.prototype, "sectors", void 0);
__decorate([
    Prop({ type: Array })
], RelatedProjectsList.prototype, "otherProjects", void 0);
__decorate([
    service.State
], RelatedProjectsList.prototype, "projects", void 0);
__decorate([
    service.Mutation
], RelatedProjectsList.prototype, "setProjects", void 0);
__decorate([
    service.Action
], RelatedProjectsList.prototype, "getProjects", void 0);
__decorate([
    Watch('projects')
], RelatedProjectsList.prototype, "onProjectsChanged", null);
RelatedProjectsList = __decorate([
    Component({
        components: {
            Project
        }
    })
], RelatedProjectsList);
export default RelatedProjectsList;
